import { render, staticRenderFns } from "./ManageCustomerBankAccount.vue?vue&type=template&id=4adbfb3c&scoped=true"
import script from "./ManageCustomerBankAccount.vue?vue&type=script&lang=js"
export * from "./ManageCustomerBankAccount.vue?vue&type=script&lang=js"
import style0 from "./ManageCustomerBankAccount.vue?vue&type=style&index=0&id=4adbfb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adbfb3c",
  null
  
)

export default component.exports